// src/components/CashManagement/CashCountModal.jsx

import React, { useState, useEffect } from 'react';

const DENOMINATIONS = [5000, 1000, 500, 100, 50, 20, 10, 5, 2, 1];

const CashCountModal = ({ isOpen, onClose, onSave , selectedInventory, existingData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    inventoryId: '',
    date: new Date().toISOString().split('T')[0],
    notes: DENOMINATIONS.map(denom => ({
      denomination: denom,
      quantity: 0
    }))
  });

  const [totalAmount, setTotalAmount] = useState(0);
  /* ✅ Sync selected inventory from parent */
  useEffect(() => {
  if (selectedInventory && selectedInventory !== 'ALL') {
    setFormData(prev => ({
      ...prev,
      inventoryId: selectedInventory
    }));
  }
}, [selectedInventory]);


  useEffect(() => {
    calculateTotal();
  }, [formData.notes]);

  const calculateTotal = () => {
    const total = formData.notes.reduce((sum, note) => {
      return sum + (note.denomination * note.quantity);
    }, 0);
    setTotalAmount(total);
  };

  const handleQuantityChange = (denomination, value) => {
    const quantity = parseInt(value) || 0;
    setFormData(prev => ({
      ...prev,
      notes: prev.notes.map(note =>
        note.denomination === denomination
          ? { ...note, quantity }
          : note
      )
    }));
  };
  //Load existing data into form
  useEffect(() => {
  if (existingData) {
    setFormData({
      inventoryId: existingData.inventoryId,
      date: existingData.date,
      notes: DENOMINATIONS.map(denom => {
        const found = existingData.notes.find(n => n.denomination === denom);
        return {
          denomination: denom,
          quantity: found ? found.quantity : 0
        };
      })
    });
  }
}, [existingData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.inventoryId || formData.inventoryId === 'ALL') {
      alert('Please select an inventory');
      return;
    }

          try {
            setIsSaving(true);
            const payload = {
        type: 'CASH_COUNT',
        inventoryId: Number(formData.inventoryId),
        totalAmount,
        date: formData.date,
        notes: formData.notes.filter(n => n.quantity > 0),
      };
      await onSave(payload);
     handleReset();   
    } catch (error) {
      console.error('Error saving cash count:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleReset = () => {
  setFormData(prev => ({
    ...prev, // keep inventoryId
    date: new Date().toISOString().split('T')[0],
    notes: DENOMINATIONS.map(denom => ({
      denomination: denom,
      quantity: 0
    }))
  }));
};

  const handleClose = () => {
    if (isSaving) return;
   
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="cash-modal-overlay" onClick={handleClose}>
      <div className="cash-modal-content large" onClick={(e) => e.stopPropagation()}>
        <div className="cash-modal-header">
          <h2>Add Cash Count</h2>
          <button className="cash-close-btn" onClick={handleClose} disabled={isSaving}>
            &times;
          </button>
        </div>

        <div className="cash-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              {/* Inventory (Locked) */}
          <div className="form-group">
            <label>Inventory</label>
            <input
              type="text"
              value={formData.inventoryId}
              disabled
            />
          </div>

              
            </div>

            <div className="denomination-grid">
              <h3>Denominations</h3>
              {formData.notes.map((note) => (
                <div key={note.denomination} className="denomination-row">
                  <label>Rs. {note.denomination}</label>
                  <input
                    type="number"
                    min="0"
                    value={note.quantity}
                    onChange={(e) => handleQuantityChange(note.denomination, e.target.value)}
                    disabled={isSaving}
                    placeholder="Qty"
                  />
                  <span className="denomination-total">
                    Rs. {(note.denomination * note.quantity).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>

            <div className="total-amount">
              <strong>Total Amount: Rs. {totalAmount.toLocaleString()}</strong>
            </div>
          </form>
        </div>

        <div className="cash-modal-footer">
          <button className="cash-btn cash-btn-cancel" onClick={handleClose} disabled={isSaving}>
            Cancel
          </button>
          <button className="cash-btn cash-btn-save" onClick={handleSubmit} disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save Cash Count'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CashCountModal;
